import CheckboxView from './checkbox-view'

export default CheckboxView
